import React from "react";

export default function EventQuestionsInput({
  eventQuestionData,
  MAX_FORM_FIELDS,
  renderTypeahead,
}) {
  return (
    <>
      {eventQuestionData &&
        eventQuestionData
          .filter((eQ, i) => {
            const withinMaxFormFieldsLimit =
              i >= eventQuestionData.length - MAX_FORM_FIELDS;
            const { showInNewMessageModal } = eQ;
            return withinMaxFormFieldsLimit && showInNewMessageModal;
          })
          .map((question) => {
            return renderTypeahead(question);
          })}
    </>
  );
}
